/**
 * This function scrolls the window to a specified vertical position with a smooth animation.
 * @param top - The vertical pixel value to scroll to from the top of the document.
 * @default 0 (scrolls to the top of the page)
 * @example
 * Scroll to 500 pixels from the top of the page
 * scrollTo(500);
 */
export function scrollTo(top = 0) {
  window.scrollTo({ top, behavior: 'smooth' })
}

interface ObserveElementOnceParams {
  el: Element
  onVisible: () => void
  options?: IntersectionObserverInit
}

/**
 * Creates an IntersectionObserver that fires `onVisible` once when the element
 * enters the viewport, then disconnects itself.
 */
export function observeElementOnce({
  el,
  onVisible,
  options,
}: ObserveElementOnceParams): IntersectionObserver {
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      onVisible()
      observer.disconnect()
    }
  }, options)
  observer.observe(el)
  return observer
}
